<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="contatoParaNotificarFalhasDeAutenticacaoLocale"
        dense
        outlined
        label="Contato para notificar falhas de autenticação"
        validate-on-blur
        hint="Máximo de 100 caracteres"
        :loading="loading"
        :rules="[validators.required, validators.emailValidator, v => (!!v && v.length <= 100) || 'Máximo de 100 caracteres']"
        @change="v => $emit('update:contatoParaNotificarFalhasDeAutenticacao', v)"
      />
    </v-col>

    <v-col cols="12">
      <v-tabs
        v-model="activeTabLocale"
        grow
        :color="activeTabLocale === 0 ? 'error' : 'info'"
        @change="v => $emit('update:activeTab', v)"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.icon"
        >
          <v-icon
            size="20"
            class="me-3"
          >
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        class="mt-5 pa-1"
      >
        <v-tab-item>
          <email-imap-smtp-tab
            v-if="activeTab === 0"
            :canal-data="canalData"
            :loading="loading"
            @update:username="v => $emit('update:username', v)"
            @update:password="v => $emit('update:password', v)"
            @update:imapHost="v => $emit('update:imapHost', v)"
            @update:imapPort="v => $emit('update:imapPort', v)"
            @update:smtpHost="v => $emit('update:smtpHost', v)"
            @update:smtpPort="v => $emit('update:smtpPort', v)"
          />
        </v-tab-item>

        <v-tab-item>
          <email-microsoft-tab
            v-if="activeTab === 1"
            :canal-data="canalData"
            @getMicrosoftAuthorizationCode="code => $emit('getMicrosoftAuthorizationCode', code)"
          />
        </v-tab-item>
      </v-tabs-items>

      <v-divider class="my-6"></v-divider>

      <email-blacklist-config :canal-id="canalData.id" />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiCogOutline, mdiEmail } from '@mdi/js'
import { required, emailValidator } from '@/@core/utils/validation'
import EmailImapSmtpTab from './EmailImapSmtpTab.vue'
import EmailMicrosoftTab from './EmailMicrosoftTab.vue'
import EmailBlacklistConfig from './EmailBlacklistConfig.vue'

export default {
  emits: ['update:activeTab', 'update:contatoParaNotificarFalhasDeAutenticacao', 'update:username', 'update:password', 'update:imapHost', 'update:imapPort', 'update:smtpHost', 'update:imapPort', 'getMicrosoftAuthorizationCode'],

  components: {
    EmailImapSmtpTab,
    EmailMicrosoftTab,
    EmailBlacklistConfig,
  },

  props: {
    canalData: {
      type: Object,
      default: null,
    },
    activeTab: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const activeTabLocale = ref(0)
    const tabs = [
      { icon: mdiCogOutline, title: 'IMAP / SMTP' },
      { icon: mdiEmail, title: 'Microsoft' },
    ]
    const contatoParaNotificarFalhasDeAutenticacaoLocale = ref(null)

    watch(
      () => props.activeTab,
      v => {
        activeTabLocale.value = v
      },
      { immediate: true },
    )
    watch(
      () => props.canalData,
      v => {
        contatoParaNotificarFalhasDeAutenticacaoLocale.value = v?.contatoParaNotificarFalhasDeAutenticacao || null
      },
      { immediate: true },
    )

    return {
      activeTabLocale,
      tabs,
      contatoParaNotificarFalhasDeAutenticacaoLocale,
      validators: {
        required,
        emailValidator,
      },
    }
  },
}
</script>
